<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { PageViewsChart } from 'coryallen-page-views'
import { ListingsCountChart, ListingsRevenueChart } from 'coryallen-listings'
import { FaqsViewChart } from 'coryallen-faqs'
import { VendorsViewChart } from 'coryallen-vendors'
import { BlogsViewChart } from 'coryallen-blogs'
import { InboxLatestChart } from 'coryallen-inbox'

import fieldPreview from '@views/global/fieldPreview';

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, PageViewsChart, ListingsCountChart, ListingsRevenueChart, FaqsViewChart, VendorsViewChart, BlogsViewChart, InboxLatestChart, fieldPreview },
  data() {
    return {
      title: 'Dashboard',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Dashboard', active: true, },
      ],
      showMessage: false,
    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <Layout>

    <PageHeader :title="title" :items="items" />

    <div v-if="hasRole(['Dev','Admin','Admin Employee'])" class="row mt-4">
      <!-- <div class="col-sm-12">
        <fieldPreview></fieldPreview>
      </div> -->
      <div class="col-sm-6">
        <ListingsCountChart></ListingsCountChart>
      </div>
      <div class="col-sm-6">
        <ListingsRevenueChart></ListingsRevenueChart>
      </div>
      <div class="col-sm-6">
        <PageViewsChart></PageViewsChart>
      </div>
      <div class="col-sm-6">
        <InboxLatestChart></InboxLatestChart>
      </div>
      <div class="col-sm-4">
        <FaqsViewChart></FaqsViewChart>
      </div>
      <div class="col-sm-4">
        <VendorsViewChart></VendorsViewChart>
      </div>
      <div class="col-sm-4">
        <BlogsViewChart></BlogsViewChart>
      </div>
    </div>

  </Layout>
</template>
